export default "__VITE_ASSET__1bifJy3K__"